jQuery(document).ready(function($) {
    EditTier = new function()
    {
        this.init = function() {
            jQuery('body').on('change', '#add-product-modal input[name="activation_code"]', function(event) {
                event.preventDefault();
                EditTier.checkForDevice();
            });

            jQuery('body').on('click', '#add-product-modal .check-activation-code', function(event) {
                event.preventDefault();
                EditTier.checkForDevice();
            });

            jQuery('body').on('change', 'select[name="modal_change_currency"]', function(event) {
                event.preventDefault();
                var currency_id = jQuery(this).find('option:selected').val();
                jQuery('.modal-edit-tier-currency').hide().removeClass('d-none');
                jQuery('.modal-edit-tier-currency[data-currency-id="'+currency_id+'"]').show();
            });

            jQuery('body').on('submit', '.tier-modal-form', function(event) {
                jQuery(this).find('input').each(function(index, el) {
                    if(!jQuery(el).val()) {
                        event.preventDefault();

                        jQuery('.modal-edit-tier-currency').hide().removeClass('d-none');
                        jQuery(el).closest('.modal-edit-tier-currency').show();
                        
                        var currency_id = jQuery(el).closest('.modal-edit-tier-currency').data('currency-id');
                        jQuery('select[name="modal_change_currency"]').val(currency_id);

                        return false;
                    }
                });
            });

            jQuery('body').on('submit', 'form.edit-product-form', function(event) {
                var original_tier_id = jQuery(this).find('input[name="original_tier_id"]').val();
                var new_tier_id      = jQuery(this).find('select[name="tier_id"] option:selected').val();
                var token            = jQuery('meta[name="csrf-token"]').attr('content');

                $.ajax({
                    url: '/devices/tierhaschanged',
                    type: 'POST',
                    data: {
                        original_tier_id:original_tier_id,
                        new_tier_id:new_tier_id,
                        _token: token
                    },
                    showloader: true,
                    success: function(response) { 
                        if(response == '1' && !jQuery(this).hasClass('confirmed-tier-change')) {
                            event.preventDefault();

                            var r = confirm("You are changing tiers. Are you sure you want to do this?");
                            if (r == true) {
                                jQuery(this).addClass('confirmed-tier-change');
                                jQuery(this).submit();
                            }
                        }
                    }
                });
            });
        };

        /**
         * Checks activation code for existing and available device
         * Use to populate the correct tiers based on the device's device_type_id
         */
        this.checkForDevice = function() {
            jQuery('#add-product-modal .error-messages').empty();;
            
            var activation_code = jQuery('#add-product-modal input[name="activation_code"]').val();
            var token           = jQuery('meta[name="csrf-token"]').attr('content');

            $.ajax({
                url: '/devices/check',
                type: 'POST',
                data: {
                    activation_code:activation_code,
                    _token: token
                },
                showloader: true,
                success: function(response) { 
                    if(response > 0) {
                        $.ajax({
                            url: '/devices/gettiers',
                            type: 'POST',
                            data: {
                                device_type_id:response,
                                _token: token
                            },
                            showloader: true,
                            success: function(response2) { 
                                jQuery('#add-product-modal select[name="tier_id"]').html(response2);
                                jQuery('#add-product-modal .show-on-activation-code-entry').show();
                                jQuery('#add-product-modal button[type="submit"]').prop('disabled', false);
                            }
                        });
                    } else {
                        jQuery('#add-product-modal .error-messages').text('No Product Found');
                        jQuery('#add-product-modal .show-on-activation-code-entry').hide();
                        jQuery('#add-product-modal button[type="submit"]').prop('disabled', true);
                    }
                }
            });
        };
    }

    EditTier.init();
});
